import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TreeView"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 15V9H16.5V11.25H12.75V5.25C12.75 4.42157 12.0784 3.75 11.25 3.75H7.5V1.5H1.5V7.5H7.5V5.25H11.25V18.75C11.25 19.5784 11.9216 20.25 12.75 20.25H16.5V22.5H22.5V16.5H16.5V18.75H12.75V12.75H16.5V15H22.5ZM6 6H3V3H6V6ZM18 18H21V21H18V18ZM18 10.5H21V13.5H18V10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TreeView.vue"]]);
